
// TODO: we should change this to use i18n
const dictionary: Record<string, string> = {
  "Invalid status transition.": "Actualización de estado incorrecta. Te recomendamos revisar el flujo y asegurarte de que cada etapa se actualice en el orden correcto"
};


function translate(key: string) {
  return dictionary[key] || key;
}

export default translate;
